const getPersonName = (person) => {
  if (!person) return "";
  if (typeof person === "string") return person.trim();
  return String(person.name || "").trim();
};

export const formatCreatedBy = (createdBy) => getPersonName(createdBy);

export const formatAssignedTo = (assignUsers) => {
  if (!assignUsers) return "";
  if (Array.isArray(assignUsers)) {
    return assignUsers.map(getPersonName).filter(Boolean).join(", ");
  }
  return getPersonName(assignUsers);
};

export const formatCreatedDate = (dateValue) => {
  if (!dateValue) return "";
  const parsed = new Date(dateValue);
  if (Number.isNaN(parsed.getTime())) return "";
  return parsed.toLocaleDateString();
};
